import { createRoute, Outlet } from '@tanstack/react-router';
import { ProtectedRoute } from '@/components/protectedRoute';
import { AdminLayout } from '@/layouts/adminLayout';
import { rootRoute } from './routes';

export const protectedLayoutRoute = createRoute({
  getParentRoute: () => rootRoute,
  id: 'protected',
  component: () => (
    <ProtectedRoute>
      <AdminLayout>
        <Outlet />
      </AdminLayout>
    </ProtectedRoute>
  ),
});
